import { useContext } from 'react';
import styled from '@emotion/styled';
import { Menu, Icon } from 'semantic-ui-react';
import { store } from '../store';
import {
  SET_ALLOW_DRAG,
  SET_SHOW_COLOR_PALETTE,
  SET_SHOW_SAVE_MODAL,
  TOGGLE_SETTINGS,
  UPDATE_GRAYSCALE,
  UPDATE_GRID,
} from '../types';
import ScaleSlider from './ScaleSlider';

const Nav = ({ onColorPick, cancelColorPicker, exportImage }) => {
  const {
    grid,
    grayscale,
    showingSettings,
    stretchImage,
    pickingColor,
    allowDrag,
    referenceColors,
    showColorPalette,
    dispatch,
  } = useContext(store);
  const setGrid = () => dispatch({ type: UPDATE_GRID, payload: !grid });
  const setGrayscale = () =>
    dispatch({ type: UPDATE_GRAYSCALE, payload: !grayscale });
  const toggleSettings = () =>
    dispatch({ type: TOGGLE_SETTINGS, payload: !showingSettings });
  const setAllowDrag = () =>
    dispatch({ type: SET_ALLOW_DRAG, payload: !allowDrag });
  const setShowColorPalette = () =>
    dispatch({ type: SET_SHOW_COLOR_PALETTE, payload: !showColorPalette });
  const savePalette = () =>
    dispatch({ type: SET_SHOW_SAVE_MODAL, payload: true });

  return (
    <Menu icon="labeled" size="small" style={{ marginBottom: 0 }}>
      <Menu.Item>
        <Logo>
          <div>Photo</div>
          <div>Reference</div>
        </Logo>
      </Menu.Item>
      <Menu.Item
        name={showColorPalette ? 'home' : 'paint brush'}
        active={showColorPalette}
        onClick={setShowColorPalette}
        color="blue"
        disabled={!referenceColors?.length}
      >
        <Icon name={showColorPalette ? 'home' : 'paint brush'} />
        {showColorPalette ? 'Home' : 'Color Palette'}
      </Menu.Item>
      {showColorPalette && (
        <Menu.Item name="save" onClick={savePalette} color="blue">
          <Icon name="save" />
          Save Palette
        </Menu.Item>
      )}
      <Menu.Menu position="right">
        {!allowDrag && (
          <Menu.Item name="download" onClick={exportImage}>
            <Icon name="download" />
            Download Image
          </Menu.Item>
        )}
        {allowDrag && (
          <Menu.Item>
            <ScaleSlider />
          </Menu.Item>
        )}
        <Menu.Item
          name="arrows alternate"
          active={stretchImage && allowDrag}
          onClick={setAllowDrag}
          color="blue"
          disabled={!stretchImage}
          title={
            stretchImage
              ? 'Drag the image to position it on the paper'
              : 'Image must be streched to fit in order to position it'
          }
        >
          <Icon name={allowDrag ? 'lock open' : 'arrows alternate'} />
          {allowDrag ? 'Save ' : ''}Position
        </Menu.Item>
        <Menu.Item
          name="grid layout"
          active={grid}
          onClick={setGrid}
          color="blue"
        >
          <Icon name="grid layout" />
          Show Grid
        </Menu.Item>
        <Menu.Item
          name="image"
          active={grayscale}
          onClick={setGrayscale}
          color="blue"
        >
          <Icon name="image" />
          Grayscale
        </Menu.Item>
        <Menu.Item
          name="eyedropper"
          active={pickingColor}
          onClick={pickingColor ? cancelColorPicker : onColorPick}
          color="blue"
        >
          <Icon name="eyedropper" />
          Color Picker
        </Menu.Item>
        <Menu.Item
          name="setting"
          active={showingSettings}
          onClick={showingSettings ? () => {} : toggleSettings}
          color="blue"
        >
          <Icon name="setting" />
          Setup
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};

const Logo = styled.div({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 20,
});

export default Nav;
